import { read } from "@/api/rest";

const projectType = {
  index: async () => await read('/project-type'),
};

export default projectType;